import type { _Toast } from ":shared/components/alerts";
import { solidstate } from ":shared/utils/state-manager";

export const $toast_group = solidstate.createGlobal<_Toast.Message[]>([]);
export const actions = {
  pushToast(alert: _Toast.Message) {
    $toast_group.set((s) => [...s, alert]);
  },
};
